import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "flex mt-8" }
const _hoisted_4 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600",
  viewBox: "0 0 100 101",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
    fill: "currentFill"
  })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

import { PropType, onMounted, ref, watch } from "vue";
import api from "@/api/api";
import { Student, Club, Goal } from "@/types";
import { goalCategories } from "@/utils/constants";
import capitalize from "@/utils/capitalize";


export default /*#__PURE__*/_defineComponent({
  __name: 'GroupGoalProgressChart',
  props: {
  club: {
    type: Object as PropType<Club>,
    required: true,
  },
  members: {
    type: Array as PropType<Student[]>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const isChartLoading = ref(true);

const selectedCategory = ref(goalCategories[0]);

const goals = ref([] as Goal[]);

const chartOptions = ref({
  chart: {
    id: "progress-goal",
  },
  xaxis: {
    categories: [],
  },
  title: {
    text: "",
  },
});

const series = ref([] as any);

async function fetchGoals() {
  const response = (await api.goals.listAllGoalsInClub(props.club.id, "active", selectedCategory.value)).data;
  goals.value = response.goals;
  series.value = response.data;
}

async function updateChart() {
  if (!goals.value.length) {
    chartOptions.value.title.text = "No goals found";
    return;
  }

  const categories = goals.value[0].progress.map(progress => {
    return new Date(progress.date!.date).toLocaleDateString();
  });

  // @ts-ignore
  chartOptions.value.xaxis.categories = categories;

  chartOptions.value.title.text = `${selectedCategory.value.charAt(0).toUpperCase() + selectedCategory.value.slice(1)}`;

  // @ts-ignore
  chartOptions.value.legend = {
    show: true,
    position: "bottom",
    horizontalAlign: "center",
    showForSingleSeries: true,
    showForNullSeries: true,
    showForZeroSeries: true,
  };
}

onMounted(async () => {
  isChartLoading.value = true;
  await fetchGoals();
  await updateChart();
  isChartLoading.value = false;
});

watch(selectedCategory, async () => {
  isChartLoading.value = true;
  await fetchGoals();
  await updateChart();
  isChartLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("select", {
        class: "block w-48 px-3 py-2 mt-1 text-base bg-white border border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50",
        name: "categories",
        id: "categories",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCategory).value = $event))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(goalCategories), (category, index) => {
          return (_openBlock(), _createElementBlock("option", {
            value: category,
            key: index
          }, _toDisplayString(_unref(capitalize)(_ctx.$t(category))), 9, _hoisted_2))
        }), 128))
      ], 512), [
        [_vModelSelect, selectedCategory.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (!isChartLoading.value)
        ? (_openBlock(), _createBlock(_component_apexchart, {
            key: 0,
            width: "800",
            type: "line",
            options: chartOptions.value,
            series: series.value
          }, null, 8, ["options", "series"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        (isChartLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})